import { useContext } from 'react';

import { useBuildingDesigner } from 'src/modules/designStudio/helpers/machete/useBuildingDesigner';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';
import { ProductCategory } from 'src/modules/designStudio/helpers/productSelection/types';
import { productCatalogContext } from 'src/modules/designStudio/providers';

export const useRoofMaterialGroups = () => {
  const { buildingAppearances } = useBuildingDesigner();
  const { pcDataStore } = useContext(productCatalogContext);

  if (buildingAppearances && pcDataStore) {
    return buildingAppearances.roofAppearances.map(appearance => ({
      appearance,
      variation: appearance.variationUUID
        ? pcDataStore.getVariationByUUID(
            appearance.variationUUID,
            ProductCategory.ROOF,
          )
        : undefined,
    })) as MaterialGroup[];
  }
  return [];
};
